// Upgrade this after each deployment.
export const APP_VERSION = '1.2.19';
export const ACCESS_TOKEN_CHANGED_EVENT = 'repeat:access-token-changed';

const KEY_PREFIX = 'REPEAT_';
const STORAGE_KEYS = {
    ADMINS: `${KEY_PREFIX}ADMINS`,
    ACCESS_TOKEN: `${KEY_PREFIX}ACCESSTOKEN`,
    USER: `${KEY_PREFIX}USER`,
    MAIL_ID: `${KEY_PREFIX}MAIL_ID`,
    VOORUITGANG: `${KEY_PREFIX}VOORUITGANG`,
    VOEDING_ID: `${KEY_PREFIX}VOEDING_ID`,
    AFSPRAKEN: `${KEY_PREFIX}AFSPRAKEN`,
    USER_DETAILS: `${KEY_PREFIX}USERDETAILS`,
    STATES: `${KEY_PREFIX}STATES`,
    KLACHT: `${KEY_PREFIX}KLACHT`,
    APP_VERSION: `${KEY_PREFIX}APP_VERSION`,
};

function safeParse(data, fallback = null) {
    if (data === null || data === undefined || data === '') {
        return fallback;
    }

    try {
        return JSON.parse(data);
    } catch (error) {
        return fallback;
    }
}

function setJsonItem(key, value) {
    if (value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
}

function clearRepeatStorage() {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);
        if (key && key.startsWith(KEY_PREFIX)) {
            keysToRemove.push(key);
        }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
}

function handleVersionMismatch() {
    clearRepeatStorage();
    setAppVersion();
}

export function getAppversion() {
    const cacheAppVersion = getAppVersion() || '1';
    if (cacheAppVersion.toString() !== APP_VERSION) {
        handleVersionMismatch();
    }
}

export function getVersionClear() {
    const cacheAppVersion = getAppVersion() || '1';
    if (cacheAppVersion.toString() !== APP_VERSION) {
        handleVersionMismatch();
        window.location.reload();
    }
}

export function signOutUser() {
    clearRepeatStorage();
}

export function clearLocalStorage() {
    clearRepeatStorage();
}

export const clearLocalData = () => {
    clearRepeatStorage();
    sessionStorage.clear();

    document.cookie.split(';').forEach((cookie) => {
        const name = cookie.split('=')[0].trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });

    if ('caches' in window) {
        caches.keys().then((names) => {
            names.forEach((name) => caches.delete(name));
        });
    }
};

export function getAdmins() {
    const data = localStorage.getItem(STORAGE_KEYS.ADMINS);
    return safeParse(data);
}

export function setAdmins(p_user) {
    setJsonItem(STORAGE_KEYS.ADMINS, p_user);
}

export function getAccesToken() {
    const data = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    return safeParse(data);
}

export function setAccesToken(p_user) {
    if (p_user) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, JSON.stringify(p_user));
    } else {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    }
    window.dispatchEvent(new CustomEvent(ACCESS_TOKEN_CHANGED_EVENT));
}

export function setUser(p_user) {
    setJsonItem(STORAGE_KEYS.USER, p_user);
}

export function getUser() {
    const data = localStorage.getItem(STORAGE_KEYS.USER);
    return safeParse(data);
}

export function setMailId(p_user) {
    setJsonItem(STORAGE_KEYS.MAIL_ID, p_user);
}

export function getMailId() {
    const data = localStorage.getItem(STORAGE_KEYS.MAIL_ID);
    return safeParse(data, '');
}

export function setVooruitgang(p_user) {
    setJsonItem(STORAGE_KEYS.VOORUITGANG, p_user);
}

export function getVooruitgang() {
    const data = localStorage.getItem(STORAGE_KEYS.VOORUITGANG);
    return safeParse(data);
}

export function setVoedingID(p_user) {
    setJsonItem(STORAGE_KEYS.VOEDING_ID, p_user);
}

export function getVoedingID() {
    const data = localStorage.getItem(STORAGE_KEYS.VOEDING_ID);
    return safeParse(data);
}

export function setAfspraken(p_afspraken) {
    if (p_afspraken?.length > 0) {
        localStorage.setItem(STORAGE_KEYS.AFSPRAKEN, JSON.stringify(p_afspraken));
    }
}

export function getAfspraken() {
    const data = localStorage.getItem(STORAGE_KEYS.AFSPRAKEN);
    return safeParse(data);
}

export function setUserdetails(p_states) {
    setJsonItem(STORAGE_KEYS.USER_DETAILS, p_states);
}

export function getUserdetails() {
    const data = localStorage.getItem(STORAGE_KEYS.USER_DETAILS);
    return safeParse(data);
}

export function setStates(p_states) {
    setJsonItem(STORAGE_KEYS.STATES, p_states);
}

export function getStates() {
    const data = localStorage.getItem(STORAGE_KEYS.STATES);
    return safeParse(data);
}

export function getPrevious(id) {
    const data = localStorage.getItem(`${KEY_PREFIX}${id}`);
    return safeParse(data);
}

export function setPrevious(id, object) {
    if (object) {
        localStorage.setItem(`${KEY_PREFIX}${id}`, JSON.stringify(object));
    }
}

export function setKlacht(p_user) {
    setJsonItem(STORAGE_KEYS.KLACHT, p_user);
}

export function getKlacht() {
    const data = localStorage.getItem(STORAGE_KEYS.KLACHT);
    return safeParse(data);
}

export function setCache(p_cache_name, p_object) {
    localStorage.setItem(`${KEY_PREFIX}${p_cache_name}`, JSON.stringify(p_object));
}

export function getCache(p_cache_name) {
    const data = localStorage.getItem(`${KEY_PREFIX}${p_cache_name}`);
    return safeParse(data);
}

export function getAppVersion() {
    return localStorage.getItem(STORAGE_KEYS.APP_VERSION);
}

export function setAppVersion() {
    localStorage.setItem(STORAGE_KEYS.APP_VERSION, APP_VERSION);
}
